module.exports = __webpack_public_path__ + "static/media/thanksImgBig.b4204b38.svg";